import { useEffect, useState } from "react";
import PaginationType from "../../../../types/pagination-type";
import ApiRequest from "../../../../lib/ApiCall";
import { numberWithCommas } from "../../../../lib/helper-support";
import moment from "moment";
import TablePagination from "../../../../components/table/table-pagination";
import DefaultModal from "../../../../components/modal/default-modal";
import { Ban } from "lucide-react";
import AddPaymentForm from "../../payment/partials/page/payment-form";

interface MemberPaymentType {
    memberId: string
}

const MemberPayment = ({memberId}: MemberPaymentType) => {

    interface PaymentType{
        reference: string
        name:string,
        description:string,
        amount:string,
        paymentType:string,
        startAt:string,
        paymentTypeId:string,
        dueAmount:string,
    }

    const [payments, setPayments] = useState<PaymentType[]>([]);
    const [data, setPageData] = useState<PaginationType>({} as PaginationType);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [paymentTypes, setPaymentTypes] = useState([]);

    const getPayments = async () => {
        const request = await ApiRequest({endpoint: `member/${memberId}/payments?page=${currentPage}`, method: 'GET'});
        request.status === '200' && setPayments(request.data.items);
        request.status === '200' && setPageData(request.data);
    }
    const fetchPaymentTypes = async () => {
        const res = await ApiRequest({ endpoint: 'payment-type', method: 'GET' });
        if (res.status === '200') setPaymentTypes(res.data.items);
    };
    const deletePayment = async (ref: string) => {
        try {
            const request = await ApiRequest({
                endpoint: `payment/${ref}/delete`,
                method: 'POST'
            });
            if (request.status === '200') {
                // Refresh list after delete
                await getPayments();
            }

        } catch (error) {
            console.error('Delete failed:', error);
        }
    };

    useEffect(() => {
        getPayments();
        fetchPaymentTypes();

    }, [currentPage]);

    return (
        <div>
            <AddPaymentForm
                openModal={openAddModal}
                onCloseModal={() => setOpenAddModal(false)}
                onSuccess={() => getPayments()}
                availablePaymentTypes={paymentTypes}
                member_id={memberId}
            />
            <h4 className="font-bold label">Payment histories


                <button onClick={() => setOpenAddModal(true)} type="button" className="pryBtnOutline text-red">
                    <span>Add Payment</span>
                </button>
            </h4>
                <div className="relative mt-2 overflow-x-auto">
                <table className='text-tertiary font-[500] text-[14px] w-full relative z-10'>
                    <thead>
                        <tr className='border-b border-[#E6EAF0] bg-[#fafafa]'>
                            <td className="px-4 py-3">Date</td>
                            <td className="px-6 py-3">Payment Type</td>
                            <td className="px-6 py-3">Amount</td>
                        </tr>
                    </thead>
                    <tbody className="relative">
                        {payments.map((payment, i) => (
                            <tr key={i} className='border-b border-[#E6EAF0]'>
                            <td className="px-4 py-3">{moment(payment.startAt).format('DD MMM, YYYY')}</td>
                            <td className="px-6 py-3">{payment.name}</td>
                            <td className="px-6 py-3">NGN {numberWithCommas(payment.amount)}</td>
                                <td className="px-6 py-3">

                                    {/* <button onClick={() => deletePayment(payment.reference)} type="button" className="pryBtnOutline text-red">
                                    <span>Delete</span>
                                </button> */}

                                    <DefaultModal
                                        buttonTriggerClassIcon={<Ban size={18} />}
                                        modalButtonTriggerText="Delete "
                                        description="Are you sure you want to delete this payment?"
                                        onConfirmationAction={() => { deletePayment(payment.reference) }}
                                        buttonTriggerClass='pryBtn bg-red-800'
                                    />
                                </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
                </div>
                 {/* pagination */}
                 <div className="mt-5">
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={data.totalPages ?? 0}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                </div>
        </div>
    );
}

export default MemberPayment